import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { browserHistory } from "react-router";
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import API from "../base/API";
import moment from "moment";
import Auth from "../auth/Auth";
import { translate } from "../base/Translation"

let DatePicker = require("react-bootstrap-date-picker");

export default class VehicleNew extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_vehicle: "/vehicle/save/new",
			get_clients: "/user/fetch/by/role/:role",
			get_brands: "/brand/fetch/all"
		});

		this.state = {
			vehicle: {
				id: 0,
				ecv: "",
				vin: "",
				name: "", // Značka
				model: "",
				registered: "01.01.2017",
				number_of_kilometers: "",
				created: null,
				updated: null,
				deleted: null,
				driver_name: "",
				driver_surname: "",
				driver_email: "",
				driver_mobile: "",
				driver_city: "",
				driver_address: "",
			},
			brands: null,
		};
	}

	saveData() {
		this.api.request({
			route: "save_vehicle",
			data: this.state.vehicle,
			created: (response) => {
				browserHistory.push("/vehicles");
			}
		});
	}

	fetchData() {
		this.api.request({
			route: "get_brands",
			success: (response) => {
				this.setState({ brands: response });
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	onVehicleChange(evt) {
		// Get vehicle from state
		let newVehicle = this.state.vehicle;

		let value = evt.target.value;

		if (evt.target.name === 'vin') {
			value = value.toUpperCase();
		}

		// Update it's value
		newVehicle[evt.target.name] = value;

		// Update vehicle in state
		this.setState({ vehicle: newVehicle });
	}

	onVehicleSave(evt) {
		this.saveData();
	}

	onRegisteredChange(evt, date) {
		// Get vehicle from state
		let newVehicle = this.state.vehicle;

		newVehicle["registered"] = date;

		// Update vehicle in state
		this.setState({ vehicle: newVehicle });
	}

	/*
	 *
	 * Render methods
	 *
	 */
	renderOptions(data) {
		let options = data.map(function (item) {
			return (
				<option value={item.id} key={item.id}>{typeof item.name !== "undefined" ? item.name : item.email}</option>
			)
		});

		return (options);
	}


	render() {

		if (this.state.brands === null) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			);
		}

		const registered = moment(this.state.vehicle.registered, "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");

		return (
			<Page>
				<PageHeader title={translate("Pridať nové vozidlo")} />
				<PageBody>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Vozidlo")}>
								<FormGroup>
									<ControlLabel>{translate("EČV")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.ecv} name="ecv" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("VIN")}</ControlLabel>
									<FormControl value={this.state.vehicle.vin} name="vin" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Značka")}</ControlLabel>
									<select name="brand" defaultValue={this.state.vehicle.brand} onChange={this.onVehicleChange.bind(this)} className="form-control">
										<option value="0">{translate("Vyberte")}</option>
										{this.renderOptions(this.state.brands)}
									</select>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Model")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.model} name="model" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Registrovaný")}</ControlLabel>
									<DatePicker dateFormat="DD.MM.YYYY" name="registered" value={registered}
										onChange={this.onRegisteredChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Počet kilometrov")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.number_of_kilometers} name="number_of_kilometers" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
							</Panel>
						</Col>
						<Col lg={6}>
							<Panel header="Vodič">
								<FormGroup>
									<ControlLabel>{translate("Meno")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.driver_name} name="driver_name" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Priezvisko")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.driver_surname} name="driver_surname" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("E-Mail")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.driver_email} name="driver_email" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Mobil")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.driver_mobile} name="driver_mobile" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Obec")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.driver_city} name="driver_city" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Adresa")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.driver_address} name="driver_address" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button bsStyle="success" onClick={this.onVehicleSave.bind(this)}>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/vehicle/VehicleNew.js